import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
export default {
  type: 'article',
  aliases: ['article'],
  path: 'Article/ArticleTemplate.vue',
  slices: [{
    name: 'article_paragraph',
    path: 'Article/ArticleParagraph.vue'
  }, {
    name: 'products_carousel_eb',
    path: 'Article/ArticleCarousel.vue'
  }, {
    name: 'article_quote',
    path: 'Article/ArticleQuote.vue'
  }, {
    name: 'article_image',
    path: 'Article/ArticleImage.vue'
  }, {
    name: 'article_chips',
    path: 'Global/GlobalChips.vue'
  }, {
    name: 'article_products',
    path: 'Article/ArticleProducts.vue',
    additional: {
      query: 'products',
      handler: function handler(arg) {
        return {
          references: arg.items.map(function (e) {
            return e.reference;
          })
        };
      }
    }
  }, {
    name: 'article_dispatch',
    path: 'Article/ArticleDispatch.vue'
  }, {
    name: 'tag_list_block',
    path: 'Global/TagListBlock.vue',
    additional: {
      query: 'categories',
      handler: function handler(arg) {
        return {
          hashes: arg.items.map(function (e) {
            return e.hash;
          })
        };
      }
    }
  }, {
    name: 'custom_button',
    path: 'Custom/CustomButton.vue'
  }, {
    name: 'landing_video_text',
    path: 'Landing/LandingVideoText.vue'
  }]
};